<div class="container">

  <app-shared-action-bar [displayActionSectionBar]="displayActionSectionBar" [saveReady]="editMade"
    [undoReady]="editMade" [alternativeBackDestination]="currentReturnURL" (localBack)="cancelEdit()"
    (undoRequest)="undoRequest()" (saveRequest)="saveCampaignChanges()"></app-shared-action-bar>

  <div class="px-4 md:px-8 mt-20">
    @if (campaigns!=undefined && !editingCampaign) {
    <div class="w-full">
      <div class="flex justify-between w-full lg:w-4/5">
        <h2 class="settings-header mb-2">Feedback Campaigns</h2>
        <span
          class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub"
          (click)="changeDisplayOptions()">settings</span>
      </div>
      @if (showOptions) {
      <div class="flex flex-col my-2">
        <div class="flex items-center">
          <app-simple-toggle [(isChecked)]="displayClosed" (isCheckedChange)="reloadPage()"></app-simple-toggle>
          <p class="ml-1">Show Closed</p>
        </div>
        <div class="flex mt-2 items-center">
          <app-simple-toggle [(isChecked)]="displayExpired" (isCheckedChange)="reloadPage()"></app-simple-toggle>
          <p class="ml-1">Show Expired</p>
        </div>
      </div>
      }
      @if (loadedCampaigns && campaigns.Campaigns.length == 0) {
      <div class="mt-4 border border-grey-500 rounded-lg p-4 w-full md:w-4/5 bg-grey-100">
        <p>There are no feedback campaigns.</p>
        <p class="mt-2">
          To create a new feedback campaign
          <button type="button" class="text-green-700 underline font-semibold" (click)="createCampaign()">click
            here</button>.
        </p>
      </div>
      }
      @if (campaigns.Campaigns.length > 0) {
      <ul class="mt-4">
        @for (c of campaigns.Campaigns; track c) {
        <li>
          <div class="flex flex-col lg:flex-row">
            <div class="border my-2 border-grey-900 rounded-lg p-4 w-full  md:w-4/5">
              <div class="flex flex-col">
                <div class="flex justify-between w-full border-b-[1px] border-b-grey-500">
                  <div class="flex items-center">
                    <div class="flex flex-col md:flex-row">
                      <h2 class="text-lg" [ngClass]="{'text-green-400':c.Active,'text-grey-900':!c.Active}">
                        {{c.RequestName}}</h2>
                      <h2 class="text-lg ml-1">&#64; {{c.Location.Description}}</h2>
                    </div>
                    @if (!c.Active) {
                    <p class="ml-1 text-grey-900">(Inactive feedback campaign)</p>
                    }
                  </div>
                  <div>
                    <div class="flex flex-row">
                      <div class="flex items-center ml-2"><span class="material-symbols-outlined">mail</span>
                        <p class="ml-2 text-center">{{c.TotalSent}}</p>
                      </div>
                      <div class="flex items-center  ml-2"><span class="material-symbols-outlined">eyeglasses_2</span>
                        <p class="ml-2 text-center">{{c.TotalAccessed}}</p>
                      </div>
                      <div class="flex items-center  ml-2"><span
                          class="material-symbols-outlined text-green-700">check</span>
                        <p class="ml-2 text-center">{{c.TotalSubmitted}}</p>
                      </div>
                      @if (c.TotalFailed>0) {
                      <div class="flex items-center ml-2"><span
                          class="material-symbols-outlined text-danger-base">report</span>
                        <p class="ml-2 text-center">{{c.TotalFailed}}</p>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="flex w-full mt-3 justify-between items-center">
                  <div class=" flex grow flex-row justify-between">
                    <div class=" flex flex-row justify-between">
                      <div class="flex-col">
                        <p class="text-sm text-green-400">Feedback Request</p>
                        <div class="flex">
                          <p>{{c.PublicAuditName}}</p>
                          @if (c.OriginalAuditName!=c.PublicAuditName) {
                          <p class="ml-1">
                            ({{c.OriginalAuditName}})</p>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-row justify-end pr-6">
                      <div class=" flex justify-between">
                        <div class="flex flex-col pr-2 ">
                          @if (true) {
                          <p class="text-sm text-green-400">Sent</p>
                          }
                          @if (false) {
                          <p class="text-sm text-green-400">Sending</p>
                          }
                          <p>{{humaniseDate(c.SendDate)}}</p>
                        </div>
                      </div>
                      <div class=" border-l-grey-500 border-l-[1px]">
                        <div class="flex flex-col  pl-2">
                          <p class="text-sm text-green-400">Expires</p>
                          <p>{{humaniseDate(c.ExpiryDate)}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col justify-between items-center ">
                    <span class="material-symbols-outlined text-2xl"
                      [ngClass]="{'hover:cursor-pointer hover:text-green-400':c.Active,'hover:cursor-not-allowed':!c.Active}"
                      (click)="editCampaign(c)">edit</span>
                    <span class="material-symbols-outlined text-2xl"
                      [ngClass]="{'hover:cursor-pointer hover:text-danger-base':c.Active,'hover:cursor-not-allowed':!c.Active}"
                      (click)="switchPendingStopCampaign(c)">front_hand</span>
                  </div>



                </div>
                @if(c.Link.length>0){


                <div>
                  <div class="flex">
                    <p class="underline cursor-pointer select-none" (click)="changeViewLink(c)">Feedback Campaign Link</p>
           
                  </div>

                  @if(c.ViewLink){
                  <div class="flex items-center mt-1">

                    <p class="text-sm">{{linkCreator(c.Link)}}</p>
         <div class="ml-2">
                      <span
                        class="material-symbols-outlined align-bottom text-xl self-center text-green-700 cursor-pointer"
                        (click)="copyLink(linkCreator(c.Link))">content_copy</span>
                      <span
                        class="material-symbols-outlined align-bottom  text-xl mr-1  self-center text-green-700 cursor-pointer"
                        (click)="openLink(linkCreator(c.Link))">open_in_new</span>
                    </div>

                  </div>
                  }


                </div>}
                @if (c.PendingStop) {
                <div class="border-t-2 mt-3 border-t-grey-500 px-2 pt-2">
                  <p class="text-sm">Stopping this feedback campaign will make all links to the feedback campaign
                    invalid. Any partially completed feedback requests will no longer be able to submit.</p>
                  <div class="flex justify-end mt-2">
                    <!--<button class="btn btn-inverse">Undo</button>-->
                    <button class="btn btn-negative" (click)="stopCampaign(c)">Stop
                      Feedback Campaign</button>
                  </div>
                </div>
                }

              </div>
            </div>
          </div>
        </li>
        }
      </ul>
      }
    </div>
    }
    @if (editingCampaign) {
    <div class="pb-3">
      <h2 class="settings-header">Edit Feedback Campaign</h2>
      <div class="mt-3 w-full lg:w-4/5 px-1">
        <div>
          <p class="text-sm text-green-400">Feedback Campaign Name</p>
          <input type="text" class="text-box" [(ngModel)]="temporaryEditCampaign.RequestName"
            (ngModelChange)="editCampaignName()" />
          @if (errCampaignName) {
          <p class="text-danger-base text-sm mx-1">Please enter a feedback campaign name.</p>
          }
        </div>
        <div class="mt-2">
          <p class="text-sm text-green-400">Public Feedback Request Name</p>
          <input type="text" class="text-box" [(ngModel)]="temporaryEditCampaign.PublicAuditName"
            (ngModelChange)="editAuditName()" />
          @if (errAuditName) {
          <p class="text-danger-base text-sm mx-1">Please enter a feedback request name.</p>
          }
        </div>
        <div class="mt-2">
          <p class="text-sm text-green-400">Send Date</p>
          <p-datepicker class="date-input mt-1" inputStyleClass="text-box" [(ngModel)]="temporaryEditCampaign.SendDate" (ngModelChange)="editSendDate()"
            dateFormat="dd M yy" [showIcon]="false"></p-datepicker>
          @if (errStartDate) {
          <p class="text-danger-base text-sm mx-1">Cannot move the start date to the past.
          </p>
          }
        </div>
        <div class="mt-2">
          <p class="text-sm text-green-400">Expiry Date</p>
          <p-datepicker class="date-input mt-1" inputStyleClass="text-box" [(ngModel)]="temporaryEditCampaign.ExpiryDate" (ngModelChange)="editExpiryDate()"
            dateFormat="dd M yy" [showIcon]="false"></p-datepicker>
          @if (errExpiryDate) {
          <p class="text-danger-base text-sm mx-1">Expiry date must be after start date.</p>
          }
        </div>
        @if (closeAuditOption) {
        <div class="my-4">
          <div class="rounded-md border-warning-base border-2 p-4 flex justify-center">
            <p class="text-lg">Setting the expiry in the past will close the feedback campaign on save.</p>
          </div>
        </div>
        }
        @if (recipientsLoaded && editRecipients.length == 0) {
        <div class="my-4">
          <div class="rounded-md border-warning-base border-2 p-4 flex justify-center">
            <p class="text-lg">Removing all recipients will close the feedback campaign on save.</p>
          </div>
        </div>
        }
        @if (!recipientsLoaded) {
        <div class="mt-4 flex justify-center">
          <button class="btn-inverse flex items-center" (click)="loadRecipients()" [disabled]="recipientsLoading"><span
              class=" mr-1 material-symbols-outlined">
              contact_mail
            </span>@if (!recipientsLoading) {
            <span>Load Recipients</span>
            }@if (recipientsLoading) {
            <span>Loading
              Recipients</span>
            }</button>
        </div>
        }
        @if (recipientsLoaded) {
        <div class="mt-4">
          @if (!showKey) {
          <div class="my-2 rounded-lg ">
            <span
              class="material-symbols-outlined text-3xl  align-bottom text-green-700 self-center  px-1 hover:cursor-pointer"
              (click)="changeHelp()">info</span>
          </div>
          }
          @if (showKey) {
          <div class="my-2 ">
            <div class="border-4 border-green-50 rounded-lg flex flex-col">
              <div class="flex justify-start">
                <span
                  class="material-symbols-outlined text-3xl  align-bottom text-green-700 self-center  px-1 hover:cursor-pointer"
                  (click)="changeHelp()">info</span>
              </div>
              <div class="flex flex-col w-full pb-3">
                <div class="flex flex-col lg:flex-row justify-center ">
                  <div class="flex flex-col justify-center items-center lg:mr-2 mt-2 lg:mt-0">
                    <span class="material-symbols-outlined text-grey-900 text-4xl">schedule</span>
                    <p class="text-sm text-center">Ready To Send</p>
                  </div>
                  <div class="flex items-center justify-center"><span
                      class="material-symbols-outlined text-3xl hidden lg:block">chevron_right</span><span
                      class="material-symbols-outlined text-3xl lg:hidden">arrow_drop_down</span></div>
                  <div class="flex flex-col justify-center items-center lg:mr-2 mt-2 lg:mt-0">
                    <span class="material-symbols-outlined text-green-400 text-4xl">mail</span>
                    <p class="text-sm text-center">Email Sent</p>
                  </div>
                  <div class="flex items-center justify-center"><span
                      class="material-symbols-outlined text-3xl hidden lg:block">chevron_right</span><span
                      class="material-symbols-outlined text-3xl lg:hidden">arrow_drop_down</span></div>
                  <div class="flex flex-col justify-center items-center mt-2 lg:mt-0">
                    <span class="material-symbols-outlined text-green-400 text-4xl">eyeglasses_2</span>
                    <p class="text-sm text-center">Accessed Link</p>
                  </div>
                  <div class="flex items-center justify-center"><span
                      class="material-symbols-outlined text-3xl hidden lg:block">chevron_right</span><span
                      class="material-symbols-outlined text-3xl lg:hidden">arrow_drop_down</span></div>
                  <div class="flex flex-col justify-center items-center lg:mr-2">
                    <span class="material-symbols-outlined text-green-400 text-4xl">check</span>
                    <p class="text-sm text-center">Submitted Results</p>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row justify-around  mt-4 lg:mt-6">
                  <div class="flex flex-col justify-center items-center mt-2 lg:mt-0">
                    <span class="material-symbols-outlined text-danger-base text-4xl">report</span>
                    <p class="text-sm text-center">Email could not reach recipient</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
          @for (r of editRecipients; track r; let last = $last) {
          <div class="border-t-[1px] border-x-[1px] border-grey-900 pl-2 py-2"
            [ngClass]="{'border-b-[1px] border-b-grey-900':last}">
            <div class="flex flex-row justify-between">
              <div class="flex w-4/5 md:hidden justify-between">
                <div>
                  <p class="text-green-400">{{r.Name}}</p>
                  <p class="text-sm mt-1"><span class="text-grey-900">Reference: </span>
                    {{r.Reference}}
                  <p class="text-sm mt-1"><span class="text-grey-900">Email: </span> {{r.Email}}
                </div>
                <div class="p-2">
                  @if (!r.Sent && !r.FailedDelivery && !r.Accessed && !r.Completed) {
                  <span class="material-symbols-outlined text-grey-900 text-4xl">schedule</span>
                  }
                  @if (r.Sent && !r.FailedDelivery && !r.Accessed && !r.Completed) {
                  <span class="material-symbols-outlined text-green-400 text-4xl mr-1">mail</span>
                  }
                  @if (r.Accessed && !r.FailedDelivery && !r.Completed) {
                  <span class="material-symbols-outlined text-green-400 text-4xl mr-1">eyeglasses_2</span>
                  }
                  @if (r.Completed && !r.FailedDelivery) {
                  <span class="material-symbols-outlined text-green-400 text-4xl">check</span>
                  }
                  @if (r.FailedDelivery) {
                  <span class="material-symbols-outlined text-danger-base text-4xl">report</span>
                  }
                </div>
              </div>
              <div class="md:flex flex-col justify-between w-2/5 border-r-[1px] hidden border-r-grey-500">
                <p class="text-green-400">{{r.Name}}</p>
                <p class="text-sm mt-1"><span class="text-grey-900">Reference: </span> {{r.Reference}}
                </p>
              </div>
              <div class="md:flex justify-between items-center hidden  flex-grow px-3 ">
                <p>{{r.Email}}</p>
                <div class="">
                  @if (!r.Sent && !r.FailedDelivery && !r.Accessed && !r.Completed) {
                  <span class="material-symbols-outlined text-grey-900 text-3xl">schedule</span>
                  }
                  @if (r.Sent && !r.FailedDelivery) {
                  <span class="material-symbols-outlined text-green-400 text-3xl mr-1">mail</span>
                  }
                  @if (r.Accessed && !r.FailedDelivery) {
                  <span class="material-symbols-outlined text-green-400 text-3xl mr-1">eyeglasses_2</span>
                  }
                  @if (r.Completed && !r.FailedDelivery) {
                  <span class="material-symbols-outlined text-green-400 text-3xl mr-1">check</span>
                  }
                  @if (r.FailedDelivery) {
                  <span class="material-symbols-outlined text-danger-base text-3xl">report</span>
                  }
                </div>
              </div>
              <div class="flex flex-col justify-center items-center px-2 border-l-[1px] border-l-grey-900 ">
                <span
                  class="text-center material-symbols-outlined text-danger-base my-auto hover:cursor-pointer hover:bg-danger-surface rounded-full"
                  (click)="removeReceipient(r.GUID)">close</span>
              </div>
            </div>
          </div>
          }
          @if (!addingNewRecipient) {
          <div
            class="flex justify-center border-x-[1px] border-x-grey-500 rounded-bl-lg rounded-br-lg border-b-[1px] border-b-grey-500"
            [ngClass]="{'bg-green-50':isHoveringAdd,'border-t-[1px] mt-2 border-t-grey-500 rounded-lg':editRecipients.length == 0}">
            <span class="text-center material-symbols-outlined text-green-400 text-5xl hover:cursor-pointer"
              (click)="showAddRecipient()" (mouseenter)="isHoveringAdd = true"
              (mouseleave)="isHoveringAdd = false">add</span>
          </div>
          }
          @if (addingNewRecipient) {
          <div class="p-2  pt-3 border-x-[1px] border-x-grey-500 "
            [ngClass]="{'border-t-[1px] mt-2 border-t-grey-500 rounded-lg':editRecipients.length == 0}">
            <div class="flex flex-col">
              <div class="flex flex-col lg:flex-row">
                <input class="text-box mt-0" type="text" placeholder="Name" [(ngModel)]="newName" />
                <input class="text-box mt-2 lg:mt-0 lg:ml-2" type="text" placeholder="Reference" [(ngModel)]="newRef" />
              </div>
              <input class="text-box mt-2" type="text" (keyup)="resetEmailValidation()" placeholder="Email"
                [(ngModel)]="newEmail" />
              @if (errorEmail) {
              <p class="text-danger-base ml-2">Invalid email format, please update.</p>
              }
              <div class="flex w-full justify-center mt-4 items-center">
                <label class="mr-2">I confirm the recipients are correct and adhere to
                  regulations</label>
                <app-simple-toggle [(isChecked)]="selectedGDPR"></app-simple-toggle>
              </div>
              <div class="flex justify-center mt-2">
                <button class="btn-primary lg:w-3/5 w-full" [disabled]="!selectedGDPR" (click)="addReceipient()">Add
                  Recipient</button>
              </div>
            </div>
          </div>
          }
          @if (addingNewRecipient) {
          <div
            class="flex justify-center border-x-[1px] mb-4 border-x-grey-500 rounded-bl-lg rounded-br-lg border-b-[1px] border-b-grey-500 py-2 border-t-[1px] border-t-grey-100"
            [ngClass]="{'bg-green-50':isHoveringAdd}">
            <span class="text-center material-symbols-outlined text-green-400 text-3xl hover:cursor-pointer"
              (click)="cancelAddRecipient()" (mouseenter)="isHoveringAdd = true"
              (mouseleave)="isHoveringAdd = false">arrow_upward</span>
          </div>
          }
        </div>
        }
  
      </div>
      <div>
      </div>
    </div>
    }

  </div>
